import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';

@Component({
    selector: 'app-enrollment-edit-step-confirmation',
    templateUrl: './enrollment-edit-step-confirmation.component.html',
    styleUrls: ['./enrollment-edit-step-confirmation.component.scss']
})
export class EnrollmentEditStepConfirmationComponent implements OnInit {

    @Input() enrollment   : EnrollmentNew;
    @Input() processResult: { state: string, result: string, message: string };

    public bankAccount: any = { titular: null, iban: null, swift: null, concept: null };
    public email      : string;

    constructor(private router: Router) { }

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        let enrollmentEdition = this.enrollment.edition;

        let bankAccountTitularResource = enrollmentEdition.resources.find(er => er.resourceId === 'bank-account-titular');
        let bankAccountIBANResource    = enrollmentEdition.resources.find(er => er.resourceId === 'bank-account-iban');
        let bankAccountSWIFTResource   = enrollmentEdition.resources.find(er => er.resourceId === 'bank-account-swift');
        let bankAccountConceptResource = enrollmentEdition.resources.find(er => er.resourceId === 'bank-account-concept');

        this.bankAccount.titular = bankAccountTitularResource ? bankAccountTitularResource.value : null;
        this.bankAccount.iban    = bankAccountIBANResource    ? bankAccountIBANResource.value    : null;
        this.bankAccount.swift   = bankAccountSWIFTResource   ? bankAccountSWIFTResource.value   : null;
        this.bankAccount.concept = bankAccountConceptResource ? bankAccountConceptResource.value : null;

        this.email = enrollmentEdition.resources.find(er => er.resourceId === 'mail-enrollment-replyto').value;

    }

    public goToDetail(enrollmentCode: string) {

        var url = `inscripcion/${enrollmentCode}/info`;
        this.router.navigate([url]);

    }

}
